import React from 'react'
import { Table, Input, Icon, Form, message, Select } from 'antd'
import TitleTop from '@pages/Assembly/titleTop'
import { Flex } from '@components';
import { createUuid } from '@utils/NHCore'
import '../index.css';

import NHFormItem from '@components/common/NHFormItem/index';
import { FormRules, regPhone } from '@utils/RegExp'
import { deepCopy } from '@utils/deepCopy'


const FormItem = Form.Item



const YHK_COMMIT_PATTERN = /^(620200|620302|620402|620403|620404|620406|620407|620409|620410|620411|620412|620502|620503|620405|620408|620512|620602|620604|620607|620611|620612|620704|620706|620707|620708|620709|620710|620609|620712|620713|620714|620802|620711|620904|620905|621001|620902|621103|621105|621106|621107|621102|621203|621204|621205|621206|621207|621208|621209|621210|621302|621303|621202|621305|621306|621307|621309|621311|621313|621211|621315|621304|621402|621404|621405|621406|621407|621408|621409|621410|621502|621317|621511|621602|621603|621604|621605|621608|621609|621610|621611|621612|621613|621614|621615|621616|621617|621607|621606|621804|621807|621813|621814|621817|621901|621904|621905|621906|621907|621908|621909|621910|621911|621912|621913|621915|622002|621903|622004|622005|622006|622007|622008|622010|622011|622012|621914|622015|622016|622003|622018|622019|622020|622102|622103|622104|622105|622013|622111|622114|622017|622110|622303|622304|622305|622306|622307|622308|622309|622314|622315|622317|622302|622402|622403|622404|622313|622504|622505|622509|622513|622517|622502|622604|622605|622606|622510|622703|622715|622806|622902|622903|622706|623002|623006|623008|623011|623012|622904|623015|623100|623202|623301|623400|623500|623602|623803|623901|623014|624100|624200|624301|624402|623700|624000)\d{12}|(622200|622202|622203|622208|621225|620058|621281|900000|621558|621559|621722|621723|620086|621226|621618|620516|621227|621288|621721|900010|623062|621670|621720|621379|621240|621724|621762|621414|621375|622926|622927|622928|622929|622930|622931|621733|621732|621372|621369|621763)\d{13}|(402791|427028|427038|548259|621376|621423|621428|621434|621761|621749|621300|621378|622944|622949|621371|621730|621734|621433|621370|621764|621464|621765|621750|621377|621367|621374|621731|621781)\d{10}|(370246|370248|370249|370247|370267|374738|374739)\d{9}|(427010|427018|427019|427020|427029|427030|427039|438125|438126|451804|451810|451811|458071|489734|489735|489736|510529|427062|524091|427064|530970|530990|558360|524047|525498|622230|622231|622232|622233|622234|622235|622237|622239|622240|622245|622238|451804|451810|451811|458071|628288|628286|622206|526836|513685|543098|458441|622246|544210|548943|356879|356880|356881|356882|528856|625330|625331|625332|622236|524374|550213|625929|625927|625939|625987|625930|625114|622159|625021|625022|625932|622889|625900|625915|625916|622171|625931|625113|625928|625914|625986|625925|625921|625926|625942|622158|625917|625922|625934|625933|625920|625924|625017|625018|625019)\d{10}|(9558)\d{15}|(45806|53098|45806|53098)\d{11}|(622210|622211|622212|622213|622214|622220|622223|622225|622229|622215|622224)\d{10}|(620054|620142|620184|620030|620050|620143|620149|620124|620183|620094|620186|620148|620185)\d{10}|(620114|620187|620046)\d{13}$/

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

const messageLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 44 }
};

/**
 * 银行卡-广东交通职业
 */
class YhkInitForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            sfyk: '',//是否有卡
            yhkh: '',// 银行卡号
            initFlag: false,
            yhkData: {},
            cacheData: {},
            editFlag: false,
            yhkShow: false,
            errorFiled: false,
        }
    }

    componentDidMount() {

        if (this.props.yhkInitData) {
            this.setState({
                yhkData: this.props.yhkInitData,
                yhkShow: this.props.yhkInitData.sfyk == '1'
            })
        }
    }

    submitCheck = (flag) => {
        const submitCheck = this.props.submitCheck;
        if (typeof submitCheck === "function") {
            submitCheck(flag);
        }
    }

    componentDidUpdate(preProps) { }

    componentWillReceiveProps(nextProps) {

        if ('yhkInitData' in nextProps) {
            const yhkInitData = nextProps.yhkInitData;
            if (yhkInitData) {
                this.setState({
                    yhkData: yhkInitData,
                });
                if (!this.state.initFlag) {
                    this.setState({
                        yhkShow: yhkInitData.sfyk == '1',
                        initFlag: true
                    })
                }
            }
        }
    }

    cacheYhkData = cb => {
        this.props.form.validateFields((err, values) => {
            const { errorFiled, sfyk, yhkh, yhkData, yhkShow } = this.state
            if (err || errorFiled) return cb(false)

            let dataList = []

            if (yhkShow) {
                const myreg = YHK_COMMIT_PATTERN
                
                console.log('yhkTest', myreg.test(yhkh));
                console.log('yhkTest', yhkh);
                if (!yhkh || !myreg.test(yhkh)) {
                    message.error("请填写正确的银行卡号");
                    return cb(false)
                }
                dataList.push({
                    pkid: yhkData.pkid,
                    sfyk: sfyk,
                    yhkh: yhkh
                })
            } else {
                dataList.push({
                    pkid: yhkData.pkid,
                    sfyk: sfyk,
                    yhkh: ''
                })
            }


            this.setState({
                editFlag: false,
            })

            const { cacheFormData } = this.props
            cacheFormData('yhk', dataList, true, 1)
            cb(true)
        })
    }


    handleChange = (value, index, key) => {
        const errorFiled = key === 'lxfs' && !regPhone(value)
        let { showJtcyData, jtcyData } = this.state
        showJtcyData[index][key] = value
        showJtcyData[index]['errorFiled'] = errorFiled
        this.setState({ jtcyData, errorFiled, showJtcyData })
    }

    getzzmmmStr = value => {
        let temp = ''
        this.state.zzmmmList.forEach(i => {
            if (i.value === value) {
                temp = i.label
            }
        })
        return temp
    }

    onSfykChange = (value) => {
        this.setState({
            sfyk: value,
            yhkShow: value == '1'
        })
    }

    onYhkChange = (event) => {
        this.setState({
            yhkh: event.target.value,
        })
    }

    render() {
        const { yhkShow, yhkData, editFlag } = this.state
        const { getFieldDecorator } = this.props.form;
        const { form, isRequired, editable } = this.props
        return (
            <div>
                <TitleTop
                    extra={editable}
                    title={<span><span style={{ display: isRequired ? '' : 'none', color: 'red' }}>*</span>{this.props.initData.FLMC}</span>}
                    onEdit={() => {
                        this.setState({
                            editFlag: true,
                            cacheData: deepCopy(yhkData),
                            sfyk: this.state.yhkData.sfyk,
                            yhkShow: this.state.yhkData.sfyk == '1'
                        })
                        this.submitCheck(false);
                    }}
                    onSave={cb => {
                        this.cacheYhkData(cb)
                    }}
                    onClose={() => {
                        this.setState({
                            editFlag: false,
                            errorFiled: false,
                            sfyk: this.state.yhkData.sfyk,
                            yhkShow: this.state.yhkData.sfyk == '1'
                        })
                        this.props.form.setFieldsValue({
                            sfyk: this.state.yhkData.sfyk
                        })
                        this.submitCheck(true);
                    }}
                />


                {
                    <div className="p-sw" >
                        <Form>
                            <div className="p-sw">
                                <div className="form_item" style={{}}>
                                    <FormItem
                                        {...formItemLayout}
                                        label="本人是否有工商银行卡"
                                    >
                                        {getFieldDecorator('sfyk', {
                                            initialValue: yhkData.sfyk,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "请选择（必选）"
                                                }],
                                        })(
                                            editFlag ?
                                                <Select placeholder="请选择" onChange={this.onSfykChange}>
                                                    <Option value="1">
                                                        是
                                                    </Option>
                                                    <Option value="2">
                                                        否
                                                    </Option>
                                                </Select> : <span>{yhkData.sfyk ? (yhkData.sfyk == '1' ? '是' : '否') : '未填写'}</span>
                                        )}
                                    </FormItem>
                                </div>
                                {yhkShow &&
                                    <div className="form_item">
                                        <FormItem
                                            {...formItemLayout}
                                            label="银行卡号"
                                        >
                                            {getFieldDecorator('yhkh', {
                                                initialValue: yhkData.yhkh,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "必须填写工商银行卡号"
                                                    },
                                                    {
                                                        pattern: YHK_COMMIT_PATTERN+""
                                                        , message: "请输入正确的工商银行卡号"
                                                    }
                                                ],
                                            })(editFlag ?
                                                <Input placeholder="请填写银行卡号"
                                                    onChange={this.onYhkChange}
                                                />
                                                : <span>{yhkData.yhkh}</span>
                                            )}
                                        </FormItem>
                                    </div>}
                                <div>

                                    <span style={{marginLeft: 15, color: 'red'}}>*</span>
                                    注意：工商银行卡是在校期间办理缴费、相关退费、资助、奖补的重要介质，与每位同学息息相关，请务必校准以上所填信息。
                                </div>
                            </div>
                        </Form>
                    </div>
                }

            </div>
        )
    }
}

const YhkFormGdjtzy = Form.create()(YhkInitForm)
export default YhkFormGdjtzy
